export default __webpack_public_path__ + "a5e6d7b1f69cda91410c7eebb821bd76.png";